import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.liveCasino,
  authRequired: false,
  gameListUrl: `popokgaming/game_list`,
  converter,
  getHeaders: () => ({
    'Content-Type': 'application/json',
    headers: { 'x-partner-name': projectName },
  }),
  sessionUrlData: {
    url: `popokgaming/token`,
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-authorization': parseCookies(), 'x-partner-name': projectName },
    }),
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
  },
};
